import { useState, useMemo } from 'react';
import type { InstagramCreator, InstagramCreatorDailyEntry, Maybe } from '@frontend/gql/social/graphql';

export type SocialStatTabKey = 'engagements' | 'reach';

export interface SocialStatsSectionProps {
  activeSocialStatTab: SocialStatTabKey;
  setActiveSocialStatTab: (tab: SocialStatTabKey) => void;
  isLoading: boolean;
  engagementsData: InstagramCreatorDailyEntry[];
  reachData: InstagramCreatorDailyEntry[];
}

export const useSocialStatsProps = (
  isLoading: boolean,
  creator?: Maybe<InstagramCreator>,
  defaultTab: SocialStatTabKey = 'engagements',
) => {
  const [activeSocialStatTab, setActiveSocialStatTab] = useState<SocialStatTabKey>(defaultTab);

  const engagementsData = useMemo(() => {
    return creator?.insights?.daily?.engagement || [];
  }, [creator?.insights?.daily?.engagement]);

  const reachData = useMemo(() => {
    return creator?.insights?.daily?.reach || [];
  }, [creator?.insights?.daily?.reach]);

  return {
    activeSocialStatTab,
    setActiveSocialStatTab,
    isLoading,
    engagementsData,
    reachData,
  };
};
